import { render, staticRenderFns } from "./yxl-bind-sucess.vue?vue&type=template&id=492a159a&scoped=true&"
import script from "./yxl-bind-sucess.vue?vue&type=script&lang=js&"
export * from "./yxl-bind-sucess.vue?vue&type=script&lang=js&"
import style0 from "./yxl-bind-sucess.vue?vue&type=style&index=0&id=492a159a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492a159a",
  null
  
)

export default component.exports